import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as onboardingActions } from "reducers/onboarding";

export const useLocalitySelectors = (stateList, generalDataBackup) => {
    const dispatch = useDispatch();
    const [lastSelectedProvince, setLastSelectedProvince] = useState("");
    const [localityList, setLocalityList] = useState([{ value: "1", label: "Villa Crespo" }]);

    const localityListRequest = useSelector((state) => state.onboarding.localityList);

    const onChangeProvince = (selectedProvince, setFieldValue) => {
        const province = stateList.find((o) => o.value === selectedProvince);

        if (!!selectedProvince && lastSelectedProvince !== selectedProvince) {
            setFieldValue("provinceName", province.label);

            setLastSelectedProvince(selectedProvince);
            if (localityList.length > 0) {
                dispatch(onboardingActions.cleanLocalityList());
            }
            const stateId = stateList.filter((state) => state.value === selectedProvince)[0].codeId || "";
            dispatch(onboardingActions.listLocalityRequest("1", Number(stateId)));
        }
    };

    useEffect(() => {
        // localityListRequest
        if (localityListRequest?.[0]?.label) {
            setLocalityList(localityListRequest);
        } else {
            setLocalityList([{ value: "1", label: "No hay localidad disponible" }]);
        }
    }, [localityListRequest]);

    useEffect(() => {
        if (generalDataBackup?.legalProvince) {
            dispatch(onboardingActions.listLocalityRequest("1", Number(generalDataBackup?.legalProvince)));
        }
    }, [generalDataBackup]);

    return {
        localityList,
        onChangeProvince,
    };
};

export default useLocalitySelectors;
